import { renderToolBlockInstance } from "../../shared/SimulatorWrapper/SimulatorWrapper";
import { forms } from "./Form/Form";
import Results from "./Results/Results";
import Footers from "./Footers/Footer";
// Define the tool key this view handles
const TOOL_KEY = "savings_certificates";

// Call the wrapper with tool-specific components and form config
renderToolBlockInstance({
  toolKey: TOOL_KEY,
  formConfig: forms[TOOL_KEY],
  Results,
  Footers,
});
